import React, { Component }      from 'react';
import PropTypes from 'prop-types';
import TreeView                             from '../../utils/tree-view';
import urlHandler                           from '../../utils/urlHandler';
import noImageAvailable                     from '../../styles/images/no-image-available.png';
import GoogleMap                            from '../demo/GoogleMap';
import MetaCartaMap                         from '../demo/MetaCartaMap';
import PersonnelTable from '../../utils/personnel-view';
import FinchButton from '../demo/FinchButton';

class KbEntityDataControl extends Component {
    constructor(props){
        super(props);

        // Parse/Process entities response to TreeView data struct
        this.getArrayChildren = this.getArrayChildren.bind(this);
        this.getObjectChildren = this.getObjectChildren.bind(this);
        this.getArrayDisplayValue = this.getArrayDisplayValue.bind(this);

        // Callbacks for TreeView
        this.getNodes = this.getNodes.bind(this);
        this.innerNode = this.innerNode.bind(this);
        this.outerNode = this.outerNode.bind(this);
        this.checkLeaf = this.checkLeaf.bind(this);
        this.getEntityData = this.getEntityData.bind(this);

        this.createTreeData = this.createTreeData.bind(this);

        // Formatters
        this.formatStocks = this.formatStocks.bind(this);

        this.state = {
            currentEntity:null,
            // { 
            //     personnelData: null,
            //     data: null,
            //     score: this.props.selectedData && this.props.selectedData.score,
            // }
            dataStack:[],
            error: null
        }

        this.IMG_NODE_VALUE = 'imageUrls';
        this.STOCKS_NODE_VALUE = 'stocks';
        this.LANGUAGE_NODE_VALUE = 'languageFields';
        this.MAP_LON_VALUE = 'longitude';
        this.MAP_LAT_VALUE = 'latitude';

        this.mapDisable = window._mapDisable;
        this.mapMetaCartaUrl = window._mapMetaCartaUrl;
        this.externalUrlsDisable = window._externalUrlsDisable;

        this.ignoreFields = [
            'contextKeywords',
            'score',
            'id',
            'description',
            'label',
            'imageUrls',
            'document'
        ]
    }

    componentDidMount() {

        const id = this.props.selectedData &&
        this.props.selectedData.document &&
        this.props.selectedData.document.id;

        if(id){
            this.getEntityData(id);        
        }
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.selectedData &&
          prevProps.selectedData.document &&
          prevProps.selectedData.document.id;

        const curId = this.props.selectedData &&
          this.props.selectedData.document &&
          this.props.selectedData.document.id;

        if (curId && (!prevId || prevId !== curId)) {
            this.getEntityData(curId);
        }   
    } 

    getEntityData(id, clearStack=true){
        urlHandler.sendRequest('entities2', null, id, null, null, (resp,txt,ent_code) => {
            if(ent_code === 200){
                const score = clearStack ? this.props.selectedData && this.props.selectedData.score : null;
                const currentEntity = {score, data: resp, treeData: this.createTreeData(resp)}
                const dataStack = clearStack ? [currentEntity]: [currentEntity, ...this.state.dataStack]

                if(this.props.permissions.kbQuery && resp.type=== 'ORGANIZATION'){
                    urlHandler.sendRequest('personnel', null, id, null, null, (pers_resp,txt,pers_code) => {
                        const error = pers_code === 200 ? null: {code: pers_code, msg: decodeURIComponent(txt)};
                        currentEntity.personnelData = error ? null : pers_resp.results.map((v)=>v.document);
                        this.setState({currentEntity, dataStack, error});
                    }); 
                }
                else{
                    this.setState({currentEntity, dataStack, error: null});
                }
            }
            else{
                this.setState({error: { code: ent_code, msg: decodeURIComponent(txt)}});
            }
        });
    }

    formatStocks(stocks) {
        var arr = [];
        Object.keys(stocks).map((stock) => {
            var str = '';
            if ('tickerSymbol' in stocks[stock]) {
                str += '(' + stocks[stock].tickerSymbol + ') ';
            }
            if ('operatingMic' in stocks[stock]) {
                str += stocks[stock].operatingMic;
            } else if ('exchange' in stocks[stock]) {
                str += stocks[stock].exchange;
            }
            arr.push(str);
        });
        return arr;
    }

    getArrayDisplayValue(arr) {
        let val = '';
        if (arr.length > 0) {
            let type = Object.prototype.toString.call(arr[0]);
            if (type != '[object Object]' && type != '[object Array]') {
                val = arr[0];
            } 
        }
        return val;
    }

    getObjectChildren(obj, level) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(obj).map((key, idx) => {
            let type = Object.prototype.toString.call(obj[key]);
            if (type === '[object Object]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    children: this.getObjectChildren(obj[key], nlevel)
                })
            } else if (type === '[object Array]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(obj[key]),
                    children: this.getArrayChildren(obj[key], nlevel)
                })
            } else {
                if (key === this.MAP_LON_VALUE && this.MAP_LAT_VALUE in obj) {
                    let bb = null;
                    if ('boundingBox' in obj) {
                        bb = obj['boundingBox'];
                    }
                    json.push({
                        name: key,
                        nameDisplay: key,
                        value: obj[key],
                        mapLon: obj[this.MAP_LON_VALUE],
                        mapLat: obj[this.MAP_LAT_VALUE],
                        mapBoundingBox: bb,
                        level: nlevel
                    })
                } else {
                    json.push({
                        name: key,
                        nameDisplay: key,
                        value: obj[key],
                        level: nlevel
                    })
                }
            }
        });
        return json;
    }

    getArrayChildren(arr, level, isImage=false) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(arr).map((key, idx) => {
            let type = Object.prototype.toString.call(arr[key]);
            if (type === '[object Object]') {
                var nameDisplay = key;
                var childObj = arr[key];
                if ('langCode' in arr[key]) {
                    nameDisplay = arr[key]['langCode'];
                    childObj = Object.assign({}, arr[key]);
                    delete childObj['langCode'];
                }
                else if ('label' in arr[key]) {
                    nameDisplay = arr[key]['label'];
                    childObj = Object.assign({}, arr[key]);
                    delete childObj['label'];
                }
                else if ('value' in arr[key]) {
                    nameDisplay = arr[key]['value'];
                    childObj = Object.assign({}, arr[key]);
                    delete childObj['value'];
                }
                json.push({
                    name: key,
                    nameDisplay,
                    level: nlevel,
                    children: this.getObjectChildren(childObj, nlevel)
                })
            } else if (type === '[object Array]') {
                let image = false;
                if (key === this.IMG_NODE_VALUE && arr[key].length > 0) {
                    image = true;
                }
                else if (key === this.STOCKS_NODE_VALUE && arr[key].length > 0) {
                    arr[key] = this.formatStocks(arr[key]);
                }
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(arr[key]),
                    isImage: image,
                    children: this.getArrayChildren(arr[key], nlevel, image)
                })
            } else if (key !== '0') {
                json.push({
                    name: key,
                    nameDisplay: '',
                    value: arr[key],
                    level: nlevel,
                    isImage
                })
            }
        });
        return json;
    }

    createTreeData(data) {
        var json = [];
        if (data) {
            var response = Object.assign({}, data);

            let level = 0;
            
            let type = 'GEO';
            if ('type' in response) {
                type = response['type'];
            }

            Object.keys(response).map((key, idx) => {
                let type = Object.prototype.toString.call(response[key]);
                if (this.ignoreFields.indexOf(key) === -1) {
                    if (type === '[object Object]') {
                        json.push({
                            name: key,
                            nameDisplay: key,
                            level, 
                            children: this.getObjectChildren(response[key], level)
                        })
                    } else if (type === '[object Array]') {
                        let isImage = false;
                        if (key === this.IMG_NODE_VALUE && response[key].length > 0) {
                            isImage = true;
                            this.setState({
                                headerImage: response[key][0]
                            })
                        }
                        else if (key === this.STOCKS_NODE_VALUE && response[key].length > 0) {
                            response[key] = this.formatStocks(response[key]);
                        }
                        json.push({
                            name: key,
                            nameDisplay: key,
                            level,
                            isImage,
                            value: this.getArrayDisplayValue(response[key]),
                            children: this.getArrayChildren(response[key], level, isImage)
                        })
                    } else {
                        if (key === this.MAP_LON_VALUE && this.MAP_LAT_VALUE in response) {
                            let bb = null;
                            if ('boundingBox' in response) {
                                bb = response['boundingBox'];
                            }
                            json.push({
                                name: key,
                                nameDisplay: key,
                                value: response[key],
                                mapLon: response[this.MAP_LON_VALUE],
                                mapLat: response[this.MAP_LAT_VALUE],
                                mapBoundingBox: bb,
                                level
                            })
                        } else {
                            json.push({
                                name: key,
                                nameDisplay: key,
                                value: response[key],
                                level
                            })
                        }
                    }
                }
            });
        }
        return json;
    }

    nodeImageError(e) {
        e.target.src = noImageAvailable;
    }

	/**
	 * Return the nodes to be displayed in the tree view. This function is initially called
	 * if the root property is not specified in the tree view
	 * @param  {object} parent The parent object linked to the node, or null if the tree needs
	 *                         	to display the root nodes
	 * @return {any}        The list of roots, or a promise object
	 */
	getNodes(parent) {
        let lst = [];
        const {currentEntity} = this.state;
        if (!parent && currentEntity && currentEntity.treeData) {
            lst = currentEntity.treeData;
        } else {
            if ('children' in parent) {
                lst = parent.children;
            }
        }
		return lst;
	}

	/**
	 * The title to be displayed, or any other composition of react components
	 * @param  {object} item The object returned by getNodes()
	 * @return {any}         String to be displayed as a title or a react component
	 */
	innerNode(item) {
        return item.nameDisplay;
	}

	/**
	 * React component that will wrap the node link. It will include 2 columns to be displayed
	 * using Twitter Bootstrap to make it responsive
	 * @param  {Component} content 	The react element containing the plus/leaf button and the title
	 * @param  {object} item    	The object linked to the node (returned by getNodes)
	 * @return {Component}         	A new component wrapping the given component
	 */
	outerNode(content, item) {
        let val = item.value;

        // Boolean values don't seem to get rendered correctly, so convert them to string.
        let type = Object.prototype.toString.call(val);
        if (type === '[object Boolean]') {
            val = val ? 'True' : 'False';
        }
        const {currentEntity} = this.state;
		return (
			<div key={item.name} className="kb-entity-node-row" style={{fontSize: '13px'}}>
				<div className="kb-entity-node-row-name">
					{content}
				</div>
                <div className="kb-entity-node-row-cols">
                    <div className="kb-entity-node-row-col-1">
                        {val}
                        {item.isImage && !this.externalUrlsDisable &&
                            <p>
                                <br/>
                                <img src={item.value} onError={this.nodeImageError}/>
                            </p>
                        }
                        {item.nameDisplay === this.MAP_LON_VALUE && item.mapLat && item.mapLon && !this.mapDisable &&
                            <div>
                                <br/>
                                {this.mapMetaCartaUrl ?
                                    <MetaCartaMap className="map-container"
                                        boundingBox={item.mapBoundingBox}
                                        lat={item.mapLat} 
                                        lng={item.mapLon}
                                        type={currentEntity.data.type}/>
                                    :
                                    <GoogleMap style={{width: '300px', height: '300px', borderRadius: '5px'}} 
                                        boundingBox={item.mapBoundingBox}
                                        lat={item.mapLat} 
                                        lng={item.mapLon}
                                        type={currentEntity.data.type}/>
                                }
                                <br/>
                            </div>
                        }
                    </div>
                </div>
			</div>
		);
	}

	/**
	 * Inform the tree if the node is a leaf, i.e, if the node has no other children
	 * @param  {[type]} item The object linked to the node, created by the <code>getNodes</code> function
	 * @return {boolean}     return true if the node is a leaf
	 */
	checkLeaf(item) {
        if ('children' in item) {
            if (item.children.length === 0) {
                return true;
            }
            return false;
        }
        return true;
    }
    render() {    
        const {currentEntity, dataStack, error} = this.state;
        return (
            <div>
            {(currentEntity || error) &&
                <div>
                    {!error &&
                        <div className="kb-entity-data-wrapper" key="1">
                            { dataStack && dataStack.length > 1 &&
                                <FinchButton
                                    warning = {true}
                                    primary={true}
                                    text = "Back"
                                    submit = {()=>{
                                        this.setState({
                                            currentEntity: dataStack[1],
                                            dataStack: dataStack.filter((_, i)=> i !== 0)
                                        })
                                    }}>
                                </FinchButton> 
                            }
                            {(currentEntity.data.imageUrls && currentEntity.data.imageUrls.length > 0) && !this.externalUrlsDisable &&
                                <img src={currentEntity.data.imageUrls[0]} 
                                    className="kb-image"
                                    onError={({ currentTarget }) => {
                                        const set = new Set(currentEntity.data.imageUrls);
                                        const newArray = Array.from(set);
                                        if(newArray.indexOf(currentTarget.src) < newArray.length-1){
                                            currentTarget.src=newArray[newArray.indexOf(currentTarget.src)+1]
                                        }
                                        else{
                                            currentTarget.style.display='none'
                                        }
                                      }}
                                />
                            }
                            <div className="kb-title">{currentEntity.data.label}</div>

                            {currentEntity.score && <div><span className="kb-label">Score: </span>{currentEntity.score.toFixed(4)}</div>}
                            <div><span className="kb-label">Id: </span>{currentEntity.data.id}</div>

                           
                                
                            <div className="kb-description-title">Description</div>
                            <div className="kb-description">{currentEntity.data.description}</div>
                            
                            { currentEntity.personnelData && currentEntity.personnelData.length > 0 &&
                                <div>
                                    <div className="kb-description-title">Key Personnel: </div>
                                    <PersonnelTable onRowClick={(id)=>{this.getEntityData(id, false)}} personnelData={currentEntity.personnelData}/>
                                </div>
                            }
                            <div className="kb-tree">
                            {currentEntity && currentEntity.treeData &&
                                <TreeView onGetNodes={this.getNodes}
                                    innerRender={this.innerNode}
                                    checkLeaf={this.checkLeaf}
                                    outerRender={this.outerNode}
                                    root={currentEntity.treeData}/>
                            }
                            </div>
                        </div>
                    }
                    {error &&
                       <div className="kb-entity-data-wrapper kb-entity-error" key="1">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="kb-entity-error-icon">
                                            <span className="fa fa-exclamation-triangle"/>
                                        </td>
                                        <td className="kb-entity-error-msg">
                                            An error occurred retrieving data<br/>
                                            <br/>
                                            <b>Code:</b> {error.code}<br/>
                                            <b>Message:</b> {error.msg} 
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }
            </div>
        );
    }
}

KbEntityDataControl.propTypes = {
    permissions: PropTypes.object.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    score: PropTypes.number
};

export default KbEntityDataControl;
